import { render, staticRenderFns } from "./hrmAddNewDocumentsModal.vue?vue&type=template&id=cfe49aca&"
import script from "./hrmAddNewDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./hrmAddNewDocumentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports